/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';

export const fundLabelStrings = {
	available: __( 'Available funds', 'woocommerce-payments' ),
	total: __( 'Total balance', 'woocommerce-payments' ),
};

export const documentationUrls = {
	depositSchedule:
		'https://woocommerce.com/document/woopayments/payouts/payout-schedule/',
	negativeBalance:
		'https://woocommerce.com/document/woopayments/fees/account-showing-negative-balance/',
};
